import { AchievementData } from "../achievements/types";
import { InvitedDonor } from "./types";

export const copyURL = (referral: string) => {
  navigator.clipboard.writeText(`${window.location.origin}/pre_sign_up/?referral-code=${referral}`);
};

const getTotalCount = (donationAgg) => {
  return Object.values(donationAgg)
    .filter(val => typeof val === 'number')
    .reduce((sum, count) => sum + count, 0);
}

export const InvitedDonorsTypeConverter = (res): InvitedDonor[] => {
  if (res.length === 0) return [];

  return res.map((el) => ({
    id: el.id,
    referral: {
      id: el.referral.id,
      firstName: el.referral.first_name,
      lastName: el.referral.last_name,
      middleName: el.referral.middle_name,
      photo: el.referral.photo
    },
    donationAgg: {
      blood: el.donation_agg.blood,
      plasma: el.donation_agg.plasma,
      platelets: el.donation_agg.platelets,
      erythrocytes: el.donation_agg.erythrocytes,
      leukocytes: el.donation_agg.leukocytes,
      unconfirmedDonations: el.donation_agg.unconfirmed_donations,
      totalCount: getTotalCount(el.donation_agg)
    },
    donorStatus: {
      id: el.donor_status.id,
      name: el.donor_status.name,
      donationsCount: el.donor_status.donations_count,
      backgroundColor: el.donor_status.background_color,
      textColor: el.donor_status.text_color,
    },
    createdAt: el.created_at
  }))
};

export function formatDate(dateString) {
  const date = new Date(dateString);

  let day: string | number = date.getDate();
  if (day < 10) day = '0' + day;

  let month: string | number = date.getMonth() + 1;
  if (month < 10) month = '0' + month;

  let year = date.getFullYear();

  return `${day}.${month}.${year}`;
}

export const getFiltersArray = (invitedDonors: InvitedDonor[]) => {
  interface DonorStatusInfo {
    [id: number]: {
      id: number,
      name: string;
      count: number;
      backgroundColor: string;
      textColor: string;
    };
  }

  const donorStatusData: DonorStatusInfo = {};
  let totalDonors = 0;

  invitedDonors.forEach((item) => {
    const statusId = item.donorStatus.id;
    const statusName = item.donorStatus.name;
    const backgroundColor = item.donorStatus.backgroundColor;
    const textColor = item.donorStatus.textColor;

    if (statusId in donorStatusData) {
      donorStatusData[statusId].count++;
    } else {
      donorStatusData[statusId] = {
        id: statusId,
        name: statusName,
        count: 1,
        backgroundColor: backgroundColor,
        textColor: textColor
      };
    }
    totalDonors++;
  });

  donorStatusData[0] = {
    id: 0,
    name: 'Все',
    count: totalDonors,
    backgroundColor: '#ffffff',
    textColor: '#333333'
  };

  return Object.values(donorStatusData);
};

export const getFilteredInvitedDonors = (invitedDonors, activeFilter) => {
  if (activeFilter[0] === 0 && activeFilter.length === 1) return invitedDonors;

  return invitedDonors.filter(item => activeFilter.includes(item.donorStatus.id));
}

export const getCountTakenAchievements = (achievements: any): AchievementData[] => {
  return achievements.filter(ach => ach.claimedDate)
    .sort((a, b) => {
      const dateA = new Date(a.claimedDate).getTime();
      const dateB = new Date(b.claimedDate).getTime();
      return dateB - dateA;
    });
}